import {
    ResultObj,
    allFetch,
} from "../Domain";
import { DDMenuItem } from "../types";

export type AttendanceStatisticResItem = {
    [key: string]: number
}

export interface AttendanceStatisticParams {
    date_start: string;
    date_end: string;
    user_ids: string[];
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    excel: string;
    check_auditing: string;
    page: number;
    num_per_page: number;
}

/**
 * @description 出勤統計
 */
export const AttendanceStatistic = async (
    obj: AttendanceStatisticParams,
): Promise<ResultObj<AttendanceStatisticResItem[]>> => {
    return await allFetch("Report/AttendanceStatistic", obj);
};


export type ScheduleXEmployeeReportResItem = {
    [key: string]: number
}

export interface ScheduleXEmployeeReportParams {
    date_start: string;
    date_end: string;
    user_ids: string[];
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    excel: string;
    page: number;
    num_per_page: number;
}

/**
 * @description 排班結果報表
 */
export const ScheduleXEmployeeReport = async (
    obj: ScheduleXEmployeeReportParams,
): Promise<ResultObj<ScheduleXEmployeeReportResItem[]>> => {
    return await allFetch("Report/ScheduleXEmployeeReport", obj);
};


export type LeaveRecordReportResItem = {
    [key: string]: number
}

export interface LeaveRecordReportParams {
    date_start: string;
    date_end: string;
    user_ids: string[];
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    excel: string;
    page: number;
    num_per_page: number;
}

/**
 * @description 排班結果報表
 */
export const LeaveRecordReport = async (
    obj: LeaveRecordReportParams,
): Promise<ResultObj<LeaveRecordReportResItem[]>> => {
    return await allFetch("Report/LeaveRecordReport", obj);
};

export type LeaveRemainAnnualReportResItem = {
    [key: string]: number
}

export interface LeaveRemainAnnualReportParams {
    isresign: string;
    user_ids: string[];
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    excel: string;
    page: number;
    num_per_page: number;
}

/**
 * @description 排班結果報表
 */
export const LeaveRemainAnnualReport = async (
    obj: LeaveRemainAnnualReportParams,
): Promise<ResultObj<LeaveRemainAnnualReportResItem[]>> => {
    return await allFetch("Report/LeaveRemainAnnualReport", obj);
};


export interface WorkClockRecordStatisticParams {
    status: string;
    date_start: string;
    date_end: string;
    user_ids: string[];
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    excel: string;
    page: number;
    num_per_page: number;
}

export interface WorkClockRecordStatisticResItem {
    DATE: string;
    name: string;
    note: string;
    place_off: string;
    place_to: string;
    sc_name: string;
    status_off: string;
    status_to: string;
    time_off: string;
    time_to: string;
    user_id: string;
    username: string;
}
/**
 * @description 打卡記錄
 */
export const WorkClockRecordStatistic = async (
    obj: WorkClockRecordStatisticParams,
): Promise<ResultObj<WorkClockRecordStatisticResItem[]>> => {
    return await allFetch("Report/WorkClockRecordStatistic", obj);
};



export interface UserReportParams {
    username?: string,
    name?: string,
    company_id?: string,
    general_manager_id?: string,
    department_id?: string,
    position_id?: string,
    class_id?: string,
    group_id?: string,
    office_id?: string,
    disable?: string,
    isresign?: string,
    ul_id?: string,
    page?: number,
    num_per_page?: number
}

export interface UserReportResItem {
}

/**
 * @description 使用者資訊報表
 */
export const UserReport = async (
    obj: UserReportParams,
): Promise<ResultObj<UserReportResItem[]>> => {
    return await allFetch("Report/UserReport", obj);
};